export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_CURRENT_LOCATION':
      localStorage.setItem('currentlocationId', action.payload.id)
      return action.payload
    default:
      return state
  }
}
